// removed by extract-text-webpack-plugin
module.exports = {"Blackberry":"#333D47","time":"Gdf37ca G2f6568 Gd71c60 undefined G813e5d"};